export default [
  {
    path: '/appview/shortcut-guide',
    name: 'shortcut-guide',
    component: () => import('@/views/appview/shortcut-guide'),
    meta: {
      title: '如何添加到桌面'
    }
  },
  
]
